import { useEffect } from 'react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export const useTrackLegalPageView = (pageName) => {
  useEffect(() => {
    const trackView = async () => {
      try {
        // Get or create a visitor ID
        let visitorId = localStorage.getItem('neura_visitor_id');
        if (!visitorId) {
          visitorId = 'v_' + Math.random().toString(36).substr(2, 9);
          localStorage.setItem('neura_visitor_id', visitorId);
        }

        // Get user email if logged in
        const customerData = sessionStorage.getItem('neura_customer');
        let userEmail = null;
        if (customerData) {
          try {
            const customer = JSON.parse(customerData);
            userEmail = customer.email;
          } catch (e) {}
        }

        await fetch(`${API_URL}/api/legal-page-view`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            page: pageName,
            visitor_id: visitorId,
            user_email: userEmail
          })
        });
      } catch (error) {
        console.error('Failed to track legal page view:', error);
      }
    };

    trackView();
  }, [pageName]);
};

export default useTrackLegalPageView;
